export default __webpack_public_path__ + "static/media/agencyLaptop-Main.603d0a1b.webp";